import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { TextArea } from "@jhool-io/fe-components";
import useToast from "../../../../../hooks/useToast";
import {
    ICommunicationNote,
    INewCommunicationNote,
} from "../../../types/clients.types";
import { useEditCommunicationNote } from "../../../hooks/clients.mutations";

interface EditCommunicationNoteProps {
    communicationNote: ICommunicationNote;
    onFormSubmit(): void;
}

const schema = yup.object({
    body: yup
        .string()
        .trim()
        .required("Note is required")
        .max(1000, "Note cannot be longer than 1000 characters"),
});

export default function EditCommunicationNote({
    communicationNote,
    onFormSubmit,
}: EditCommunicationNoteProps) {
    const params = useParams();
    const clientId = params.clientId as string;

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<INewCommunicationNote>({
        resolver: yupResolver(schema),
    });

    const editCommunicationNote = useEditCommunicationNote(clientId);

    const { toast } = useToast();

    const onSubmit = (noteData: INewCommunicationNote) => {
        editCommunicationNote.mutate(
            {
                communicationNoteId: communicationNote.communication_note_id,
                body: noteData.body,
            },
            {
                onSuccess: (res) => {
                    toast({
                        mode: "success",
                        message: res.message || "Note updated successfully",
                    });
                    onFormSubmit();
                },
                onError: (err) => {
                    toast({
                        mode: "error",
                        message:
                            err.response?.data.message ||
                            "Could not update note at this time",
                    });
                },
            }
        );
    };

    return (
        <form id="edit-communication-note" onSubmit={handleSubmit(onSubmit)}>
            <div className="fg">
                <TextArea
                    {...register("body")}
                    label="Note"
                    defaultValue={communicationNote.body}
                    hasError={!!errors.body}
                    errorText={errors.body?.message}
                />
            </div>
        </form>
    );
}
